import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";
import { ApiRequest } from "../../Common";
import { FeedbackFile } from "../Models/FeedbackFile";
import { DeleteFile } from "../Models/DeleteFile";

class FileUploadService {
  uploadFile(
    endpoint: string,
    fileToUpload: FeedbackFile,
    success: (image: FeedbackFile, response: Response, result: ResponseResult) => void,
    hasDuplicate: (hash: string) => FeedbackFile | undefined,
    onDuplicate: () => void,
    onError: (response: Response, result: ResponseResult) => void,
    onFatalError: (response: Response) => void,
    cleanup?: () => void
  ) {
    const formData = new FormData();

    const file = { ...fileToUpload };

    if (fileToUpload.file) {
      formData.append(fileToUpload.file.name, fileToUpload.file);

      return ApiRequest.fromPath(endpoint)
        .withFormData(formData)
        .withAuthHeader()
        .post()
        .then((response: Response) => {
          ResponseHandler.handle(
            response,
            (result: ResponseResult<FeedbackFile>) => {
              const { path, hash, url, filename, extension, isCadmakersOnly } = result.payload;

              const duplicate = hasDuplicate(hash);

              if (!duplicate) {
                file.path = path;
                file.hash = hash;
                file.url = url;
                file.filename = filename;
                file.extension = extension;
                file.isCadmakersOnly = isCadmakersOnly;

                success(file, response, result);
              } else {
                onDuplicate();
              }
            },
            result => {
              onError(response, result);
            },
            () => {
              onFatalError(response);
            }
          );
        })
        .finally(() => {
          if (cleanup) {
            cleanup();
          }
        });
    }

    throw new Error("File cannot be undefined.");
  }

  deleteFile(
    endpoint: string,
    deleteFile: DeleteFile,
    success: (response: Response, result: ResponseResult) => void,
    onError: (response: Response, result: ResponseResult) => void,
    onFatalError: (response: Response) => void
  ) {
    ApiRequest.fromPath(endpoint)
      .withAuthHeader()
      .withJson(deleteFile)
      .delete()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          result => {
            success(response, result);
          },
          result => {
            onError(response, result);
          },
          () => {
            onFatalError(response);
          }
        );
      });
  }
}

export const fileUploadService = new FileUploadService();
